// extracted by mini-css-extract-plugin
export default {"container":"nWl5JmCMUhJ4hVsQ4ORA"};